<a [attr.href]="href" class="dropdown-item px-4 c-cursor-pointer" [attr.data-cy]="'productsMenu-product-' + id">
	{{ name }}
</a>
